import React from "react";
import styles from "./InputForm.module.scss";
import { InputText, InputTextProps } from "../Inputs/InputText/InputText";
import clsx from "clsx";
import { Button } from "../../Button/Button";

export interface InputFormProps extends InputTextProps {
  placeholder: string;
  formAction?: string;
  inputType?: "text" | "search" | "email";
  className?: string;
  icon?: "action" | "search";
  onSubmitAction?: React.FormEventHandler<HTMLFormElement>;
  buttonVariant: "transparent" | "white" | "primary";
  dataContentPiece?: string;
}

const FormWrap = ({ condition, children, props }) =>
  condition ? (
    <form
      className={clsx(styles.inputContainer, props.className)}
      action={props.formAction}
      onSubmit={props.onSubmitAction}
    >
      {children}
    </form>
  ) : (
    <div className={styles.inputContainer}>{children}</div>
  );

export const InputForm: React.FC<React.PropsWithChildren<InputFormProps>> = ({
  placeholder,
  formAction = undefined,
  className,
  inputType = "text",
  icon = "action",
  onSubmitAction = undefined,
  buttonVariant = "transparent",
  dataContentPiece,
  ...inputProps
}) => {
  const iconName = icon
    ? icon == "action"
      ? "chevron-right"
      : "search"
    : undefined;

  const dataContentPieceValue =
    dataContentPiece || inputProps["data-content-piece"];

  return (
    <FormWrap
      condition={!!formAction}
      props={{ formAction, onSubmitAction, className }}
    >
      <React.Fragment>
        <InputText
          className={styles.input}
          type={inputType}
          placeholder={placeholder}
          {...inputProps}
        />
        <Button
          className={styles.submitButton}
          iconName={iconName}
          dataContentPiece={dataContentPieceValue}
          aria-label={placeholder}
          variant="primary"
          inverted={buttonVariant === "white"}
          disabled={inputProps.disabled}
        ></Button>
      </React.Fragment>
    </FormWrap>
  );
};
